











































































import { Component, Vue } from 'vue-property-decorator';
import AppNavigator from '@/components/AppNavigator.vue';
import SectionWelcome from '@/components/SectionWelcome.vue';
import SectionGame from '@/components/SectionGames.vue';
import SectionCompany from '@/components/SectionCompany.vue';
import AppFooter from '@/components/AppFooter.vue';
import LoginDialog from '@/components/LoginDialog.vue';
import RegisterDialog from '@/components/RegisterDialog.vue';
import DepositDialog from '@/components/DepositDialog.vue';
import WithdrawDialog from '@/components/WithdrawDialog.vue';
import PromotionDialog from '@/components/PromotionDialog.vue';
import ContactDialog from '@/components/ContactDialog.vue';
import DialogConnector from '@/connector/Dialog.vue';
import BaseSnackbar from '@/components/BaseSnackbar.vue';
import FortuneWheelDialog from '@/components/FortuneWheelDialog.vue';
import SummaryDialog from '@/components/SummaryDialog.vue';
import AffiliateDialog from '@/components/AffiliateDialog.vue';
import ProfileDialog from '@/components/ProfileDialog.vue';
import Visibility from 'visibilityjs';
import RefundLossDialog from '@/components/RefundLossDialog.vue';
import ResetPasswordDialog from '@/components/ResetPasswordDialog.vue';
import AffiliateWithdrawDialog from '@/components/AffiliateWithdrawDialog.vue';
import Pusher from 'pusher-js';
import BankConfig from '@/connector/BankConfig.vue';
import DepositChoice from '@/components/DepositChoice.vue';

@Component({
  components: {
    AppNavigator,
    SectionWelcome,
    SectionGame,
    SectionCompany,
    AppFooter,
    LoginDialog,
    DialogConnector,
    BaseSnackbar,
    RegisterDialog,
    DepositDialog,
    WithdrawDialog,
    PromotionDialog,
    ContactDialog,
    FortuneWheelDialog,
    SummaryDialog,
    AffiliateDialog,
    ProfileDialog,
    RefundLossDialog,
    ResetPasswordDialog,
    AffiliateWithdrawDialog,
    BankConfig,
  },
})
export default class NewHome extends Vue {
  public maintanance: boolean = false;

  async created() {
    const { ref, register, login } = this.$route.query;
    if (ref) {
      await localStorage.setItem('ufa-auto-reference', String(ref));
    }
    console.log('dialog', register);
    if (register) {
      this.$store.dispatch('Dialog/updateDialog', { dialogType: 'RegisterDialog', open: true });
    }
    if (login) {
      this.$store.dispatch('Dialog/updateDialog', { dialogType: 'LoginDialog', open: true });
    }
    Visibility.change(async () => {
      if (!Visibility.hidden()) {
        await this.$store.dispatch('Auth/autoLogin');
      }
    });
  }
}
